import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

export class ProductItem{
  constructor(){}
  public itemId : number;
  public item : string;
}

@Injectable({
  providedIn: 'root'
})

export class ProductitemService {
  
  constructor(private httpClient:HttpClient) { }

  public getProductItems() : Observable<ProductItem[]> {
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.get<ProductItem[]>('/api/v1/item/',{headers})
    .pipe(catchError(this.errorHandler));
  }

  public getProductItemsInReportShow() : Observable<ProductItem[]> {
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.get<ProductItem[]>('/api/v1/item/report-show',{headers})
    .pipe(catchError(this.errorHandler));
  }

  public createProductItem(obj : any) : Observable<any>{
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.post<any>('/api/v1/item/' , obj , {headers}).pipe(catchError(this.errorHandler));
  }
  
  updateProductItem(bean: any): Observable<any> {
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.put<any>('/api/v1/item/' , bean , {headers}).pipe(catchError(this.errorHandler));
  }

  public deleteProductItem(Id: number){
    return this.httpClient.delete('api/v1/item/' + Id);
  }

  errorHandler(error: HttpErrorResponse){
    console.log(error.message);
    return throwError(error.message || 'Server Error');
  }
}
